import { classifyError } from './errorClassifier';
import { shouldSendError } from './errorDeduplication';
import { getSentry } from './index';
import { stopReplay } from './replayController';
import { createTags } from './tags';
import type { SentryLogOptions } from './types';

export const sentryCaptureError = (error: unknown, options?: SentryLogOptions) => {
  try {
    const Sentry = getSentry();
    if (!Sentry) return;

    const scope = Sentry.getCurrentScope();
    const sessionId = options?.sessionId || scope?.getScopeData()?.tags?.sessionId || 'no-session';

    const severity = classifyError(error);

    // ☠️ fatal → stop replay
    if (severity === 'fatal') {
      stopReplay('fatal-error');
    }

    const allowed = shouldSendError(error, String(sessionId), severity);

    if (!allowed && severity === 'recoverable') {
      // recoverable мы всё равно логируем
      Sentry.captureException(error, {
        level: 'warning',
        tags: {
          ...createTags(options || {}),
          error_severity: 'recoverable-suppressed',
        },
      });
      return;
    }

    if (!allowed) {
      return;
    }

    Sentry.captureException(error, {
      level: severity === 'fatal' ? 'fatal' : 'error',
      tags: {
        ...createTags(options || {}),
        error_severity: severity,
      },
      extra: options?.extra,
    });
  } catch (e) {
    console.error('Sentry capture failed', e);
  }
};

export const sentryCaptureLog = (message: unknown, options: SentryLogOptions) => {
  try {
    const Sentry = getSentry();
    if (!Sentry) return;

    Sentry.captureMessage(`[${options.loggerId}] ${message}`, {
      level: options.level || 'info',
      tags: createTags(options),
      extra: options.extra,
    });
  } catch (e) {
    console.error('Sentry log failed', e);
  }
};
